import { render, staticRenderFns } from "./TankLorryMonitor.vue?vue&type=template&id=4188c886"
import script from "./TankLorryMonitor.vue?vue&type=script&lang=js"
export * from "./TankLorryMonitor.vue?vue&type=script&lang=js"
import style0 from "./TankLorryMonitor.vue?vue&type=style&index=0&id=4188c886&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports